import Vue from "vue";

import VueRouter from 'vue-router'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {//重定向:当访问/时立即定向该路径
      path: '*',
      redirect: '/home',
    },
    {//首页
      path: '/home',
      component: () => import('@/views/Home'),
    },
    {//登录注册页
      path: '/voice',
      component: () => import('@/views/Voice'),
    },
    {//个人中心--客户页
      name: 'personal',
      path: '/personal',
      component: () => import('@/views/Personal'),
      redirect: '/information',
      children: [
        {//基本信息--首页
          // name: 'information',
          path: '/information',
          component: () => import('@/views/Information'),
        },
        {//个人中心--企业认证
          path: '/enterprise',
          component: () => import('@/views/ProperCenter/Enterprise'),
        },
        {//个人中心--修改密码
          path: '/modifypsw',
          component: () => import('@/views/ProperCenter/ModifyPsw'),
        },
        {//个人中心--换绑手机
          path: '/exchangetel',
          component: () => import('@/views/ProperCenter/ExchangeTel'),
        },
        {//充值管理--在线充值
          path: '/onlinetop',
          component: () => import('@/views/Management/OnlineTop'),
        },
        {//充值管理--充值记录
          path: '/record',
          component: () => import('@/views/Management/Record'),
        },
        {//短信发送--模板库
          path: '/sendtemplate',
          component: () => import('@/views/NoteSend/SendTemplate'),
          children: [
            {
              path: '/createtent',
              component: () => import('@/views/NoteSend/Assistant/CreateTent'),
            }
          ]
        },
        {//短信发送--发送助手
          path: '/assistant',
          component: () => import('@/views/NoteSend/Assistant'),
        },
        {//短信内容发送--批量导入
          path: '/piliang',
          component: () => import('@/views/NoteSend/piLiang'),
        },
        {//短信参数发送--批量导入
          path: '/piliangcs',
          component: () => import('@/views/NoteSend/piLiangCs'),
        },
        {//短信发送--发送记录
          path: '/sendrecord',
          component: () => import('@/views/NoteSend/SendRecord'),
        },
        {//短信发送--发送详情
          path: '/sendchart',
          component: () => import('@/views/StatisticalChart/SendChart'),
        },
        {//短信发送--批量SIM卡发送
          path: '/sendSIMchart',
          component: () => import('@/views/StatisticalChart/sendSIMchart'),
        },
        {//短信发送--发送统计
          path: '/statistics',
          component: () => import('@/views/StatisticalChart/Statistics'),
        },
        {//短信发送--设备发送
          path: '/deviceTransmission',
          component: () => import('@/views/StatisticalChart/deviceTransmission'),
        },
        {//短信发送--上行详情
          path: '/uplinkDetails',
          component: () => import('@/views/StatisticalChart/uplinkDetails'),
        },
        {//---
          path: '/importexcel',
          component: () => import('@/views/ImportExcel'),
        },
        {//smscard
          path: '/smscard',
          component: () => import('@/views/smscard'),
        },
      ]
    },
    {//---
      path: '/aaa',
      component: () => import('@/views/aaa'),
    },
  ]

})
